export const EXSBWAREHOUSE_CREATE_RESET = 'EXSBWAREHOUSE_CREATE_RESET'
export const EXSBWAREHOUSE_CREATE_SET_CREATED = 'EXSBWAREHOUSE_CREATE_SET_CREATED'
export const EXSBWAREHOUSE_CREATE_SET_ERROR = 'EXSBWAREHOUSE_CREATE_SET_ERROR'
export const EXSBWAREHOUSE_CREATE_SET_VIOLATIONS = 'EXSBWAREHOUSE_CREATE_SET_VIOLATIONS'
export const EXSBWAREHOUSE_CREATE_TOGGLE_LOADING = 'EXSBWAREHOUSE_CREATE_TOGGLE_LOADING'
